import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { decorators, DataRow, getPaginator } from '@orange-marmalade/paginate-this';
import cx from 'classnames';

// ducks
import { paginateThis } from '../../ducks/GolfCourseSearch';

// components
import LoadError from '../../components/load-error/load-error';

// contianers
import GolfCourseSearchResult from './GolfCourseSearchResult';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';

class GolfCourseSearchResults extends PureComponent {
  render() {
    const { ids, className, isLoading, loadError, reload } = this.props;

    return (
      <div className={cx(className, styles.results)}>
        {ids.map((id, i) => {
          return (
            <DataRow itemId={id} component={GolfCourseSearchResult} index={i} key={i} />
          );
        })}
        {loadError && !isLoading && <LoadError error={loadError} retry={reload} />}
        {ids.length === 0 && !isLoading && !loadError && (
          <div className={`${BS.mb3} ${BS.textCenter}`}>No Results</div>
        )}
        {isLoading && <div className={BS.loadingMask}>LOADING</div>}
      </div>
    );
  }
}

export default decorators.tabulateLean(
  connect(
    (state, props) => {
      const paginator = getPaginator(props.listId, state),
        loadError = paginator.get('loadError');

      return {
        loadError
      };
    },
    {
      reload: paginateThis.pageActions.reload
    }
  )(GolfCourseSearchResults)
);



// WEBPACK FOOTER //
// ./src/containers/GolfCourseSearch/GolfCourseSearchResults.js